import { createSlice } from '@reduxjs/toolkit';
import { configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['form'],
};
const onBoardingSlice = createSlice({
  name: 'form',
  initialState: {
    currentPage: 0,
    formValues: {
      basicDetails: {},
      products: [],
      blood: 0,
      oxygen: 0,
      consumable: 0,
      procurement: 'daily',
      payment: 'daily',
      challenge: '',
      change: '',
      workWithUsMessage: '',
      radioBtnWorkWithUs: '',
      radioBtnCurrentSupply: '',
      tryLifeBank: '',
    },
  },

  reducers: {
    nextPage: (state) => {
      state.currentPage += 1;
    },
    previousPage: (state) => {
      state.currentPage -= 1;
    },
    basicDetails: (state, action) => {
      state.formValues.basicDetails = action.payload;
    },
    setProducts: (state, action) => {
      state.formValues.products = action.payload;
    },
    setFormValue: (state, action) => {
      const { name, value } = action.payload;
      state.formValues[name] = value;
    },

    setDate: (state, action) => {
      state.selectedDate = action.payload;
    },
    addProduct: (state, action) => {
      const newProduct = action.payload;
      const { products } = state.formValues;
      if (products.length < 4 && !products.includes(newProduct)) {
        state.formValues.products = [...products, newProduct];
      }
    },

    removeProduct: (state, action) => {
      state.formValues.products = state.formValues.products.filter(
        (product) => product !== action.payload
      );
    },

    bloodIncrementCounter: (state) => {
      state.formValues.blood += 1;
    },

    bloodDecrementCounter: (state) => {
      if (state.formValues.blood > 0) {
        state.formValues.blood -= 1;
      }
    },

    oxygenIncrementCounter: (state) => {
      state.formValues.oxygen += 1;
    },

    oxygenDecrementCounter: (state) => {
      if (state.formValues.oxygen > 0) {
        state.formValues.oxygen -= 1;
      }
    },

    consumableProductsIncrementCounter: (state) => {
      state.formValues.consumable += 1;
    },

    consumableProductsDecrementCounter: (state) => {
      if (state.formValues.consumable > 0) {
        state.formValues.consumable -= 1;
      }
    },

    procurement: (state, action) => {
      state.formValues.procurement = action.payload;
    },

    payment: (state, action) => {
      state.formValues.payment = action.payload;
    },

    challenge: (state, action) => {
      state.formValues.challenge = action.payload;
    },

    change: (state, action) => {
      state.formValues.change = action.payload;
    },

    radioBtnCurrentSupply: (state, action) => {
      state.radioBtnCurrentSupply = action.payload;
    },

    tryLifeBank: (state, action) => {
      state.formValues.tryLifeBank = action.payload;
    },

    workWithUsMessage: (state, action) => {
      state.formValues.workWithUs = action.payload;
    },

    radioBtnWorkWithUs: (state, action) => {
      state.radioBtnWorkWithUs = action.payload;
    },
    setOrderHistory: (state, action) => {
      const { name, value } = action.payload;
      state.formValues = { ...state.formValues, [name]: value };
    },
  },
});

const persistedReducer = persistReducer(persistConfig, onBoardingSlice.reducer);

const onBoardStore = configureStore({
  reducer: {
    form: persistedReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});

export const updateBasicDetails = (data) => {
  return (dispatch) => {
    dispatch(onBoardingSlice.actions.basicDetails(data));
  };
};

export const {
  nextPage,
  currentPage,
  previousPage,
  basicDetails,
  setProducts,
  addProduct,
  removeProduct,
  bloodIncrementCounter,
  bloodDecrementCounter,
  oxygenIncrementCounter,
  oxygenDecrementCounter,
  consumableProductsIncrementCounter,
  consumableProductsDecrementCounter,
  procurement,
  payment,
  challenge,
  change,
  radioBtnCurrentSupply,
  tryLifeBank,
  workWithUsMessage,
  radioBtnWorkWithUs,
  setOrderHistory,
  setFormValue,
  setDate,
} = onBoardingSlice.actions;

export default onBoardStore;

// export const persistor = persistStore(onBoardStore);
